export const directDebitCacheKeys = {
  complete: () => ['accountDirectDebitCompletion'] as const,
  initiate: () => ['accountDirectDebitInit'] as const
}
